<template>
    <v-app>
      <!-- Navbar (Mobile) -->
      <div v-if="windowSize < 2">
        <v-app-bar
          app
          color="black"
          dark
          shrink-on-scroll
          clipped-left
          :src="currentImage"
          height="200"
          lazy-src="https://picsum.photos/id/11/100/60"
        >
          <template v-slot:img="{ props }">
            <v-img
              v-bind="props"
              gradient="to top right, rgba(0, 0, 0,.5), rgba(128,128,128,.3)"
            ></v-img>
          </template>

          <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          <img width="100vw" :src="require('./assets/logo_proa-int.png')"/>
        </v-app-bar>

        <v-navigation-drawer
            v-model="drawer"
            app
            persistent
            clipped
            disable-resize-watcher
            color="#171717"
          >
          <v-list-item dark>
            <v-list-item-content class="text-center">
              <v-list-item-title class="title">
                <v-img
                  class="shrink"
                  contain
                  :src="require('./assets/logo_proa-int.png')"
                  transition="scale-transition"
                  width="80%"
                  @click="pushAndResetNav('/')"
                />
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list
            dark
            nav
          >
            <v-list-item
              link
              @click="pushAndResetNav(linksMobile[0].to)"
            >
              <v-list-item-content>
                <v-list-item-title>HOME</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
                :value=false
              >
                <template v-slot:activator>
                  <v-list-item-title>VERTICALS</v-list-item-title>
                </template>
                <v-list-item
                  v-for="item in linksMobile[1].items"
                  :key="item.text"
                  link
                  @click="pushAndResetNav(item.to)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
          </v-list>

        </v-navigation-drawer>
      </div>

      <!-- Navbar (Desktop) -->
      <div v-else>
        <v-layout row wrap px-8 py-6 class="navbar text-center" :style="{ backgroundImage: 'url('+currentImage+')' }">
          <v-flex xs5 pb-2 px-8>
            <!-- Logo -->
            <v-img
              min-width="20%"
              max-width="20%"
              :src="require('./assets/logo_proa-int.png')"
            ></v-img>
          </v-flex>
          <v-spacer></v-spacer>
          <!-- Router Links -->
          <v-flex
            px-1
            py-4
            xs1
            v-for="link in links"
            :key="link.text"
          >
            <a
              :style="[ link.selected ? {'font-weight': 'bold', 'color': '#f05f32'} : {'font-weight': 'normal', 'color': 'white'}]"
              @click="goLink(link)"
            >{{ link.text }}</a>
          </v-flex>
          <v-flex px-1 py-4 xs1>
            <a
              href="#"
              v-scroll-to="'#quienes_somos'"
              style="font-weight: normal; color: white; text-decoration: none"
              @click="goScroll('quienes_somos')"
            >WHO WE ARE</a>
          </v-flex>
          <v-flex px-1 py-4 xs1>
            <a
              href="#"
              v-scroll-to="'#contacto'"
              style="font-weight: normal; color: white; text-decoration: none"
              @click="goScroll('contacto')"
            >CONTACT</a>
          </v-flex>
          <v-flex xs12 pb-12>
            <v-divider dark></v-divider>
          </v-flex>
          <!-- Carrousel -->
          <v-window v-model="windowHome" :style="[['home'].indexOf($route.name) > -1  ? {'height': '81vh'} : {'height': '400px'}]" class="align">
            <v-window-item>
              <v-flex v-if="['home'].indexOf($route.name) > -1" xs7 sm3 md5 lg3 offset-xs2 offset-sm3 pa-12 white--text>
                <h1 class="display-2 font-weight-bold py-3">ACCESS SOLUTIONS</h1>
                <p class="font-weight-light">Our experience in access solutions has positioned us as the <b><i>Number #1</i></b> integrators, offering a complete and sustainable solution to satisfy any need</p>
              </v-flex>
              <v-flex v-else xs7 sm3 md5 lg3 offset-xs2 offset-sm3 pa-12 white--text>
                <hr class="line">
                <p class="display-2 font-weight-bold text-uppercase">{{ vertical }}</p>
              </v-flex>
            </v-window-item>
            <v-window-item>
              <v-flex v-if="['home'].indexOf($route.name) > -1" xs7 sm3 md5 lg4 offset-xs2 offset-sm3 pa-12 white--text>
                <hr class="line">
                <p class="display-2 font-weight-bold">ACCESS SOLUTIONS</p>
                <p class="font-weight-light">Our experience in access solutions has positioned us as the <b><i>Number #1</i></b> integrators, offering a complete and sustainable solution to satisfy any need</p>
              </v-flex>
              <v-flex v-else xs7 sm3 md5 lg3 offset-xs2 pa-12 white--text>
                <br><br><br>
                <hr class="line2">
                <p class="display-2 font-weight-bold text-uppercase">{{ vertical }}</p>
              </v-flex>
            </v-window-item>
          </v-window>
          <v-flex xs6 offset-xs6 text-left>
            <v-icon x-large dark>keyboard_arrow_down</v-icon>
          </v-flex>
        </v-layout>
      </div>

      <!-- Router View -->
      <v-content>
        <router-view @goLink="goLink"/>
      </v-content>

      <!-- Footer -->
      <v-footer color="secondary">
        <v-layout row wrap text-center py-12>
          <v-flex xs6 md2 offset-md2 pb-8>
            <a href="#" style="color: grey">Twitter</a>
          </v-flex>
          <v-flex xs6 md2 pb-8>
            <a href="https://www.facebook.com/pages/category/Local-Business/PROA-408440155931038/" style="color: grey">Facebook</a>
          </v-flex>
          <v-flex xs6 md2 pb-8>
            <a href="#" style="color: grey">Instagram</a>
          </v-flex>
          <v-flex xs6 md2 pb-8>
            <a href="https://www.linkedin.com/company/proa" style="color: grey">LinkedIn</a>
          </v-flex>
          <v-flex xs12 md4 offset-xs1 white--text>
            <v-layout row wrap>
              <v-flex xs12 md8 offset-xs3 offset-md0>
                <v-img
                  max-width="35%"
                  :src="require('./assets/logo_proa-int.png')"
                ></v-img>
              </v-flex>
              <v-flex xs10 md4>
                <a href="mailto:contact@proainternational.com?" style="color: white;">contact@proainternational.com</a>
                <div>+52 81 8040 8510</div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="text-center" white--text pt-4>
            Copyright © PROA, {{ new Date().getFullYear() }} - Powered by <a style="color: white;" href="https://www.softher.mx"><b>Softher</b></a>
            <div><a href="#" style="color: grey">Privacy</a></div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data: () => ({
    windowHome: 1,
    drawer: false,
    currentImage: null,
    vertical: '',
    links: [
      {
        text: 'HOME',
        to: '/',
        image: 'header1_home.png',
        selected: false
      },
      {
        text: 'VERTICALS',
        to: '/verticales/hotel',
        image: 'hoteleria_cityexpressv2.jpg',
        selected: false
      }
    ],
    linksMobile: [
      {
        text: 'HOME',
        to: '/',
        image: 'header1_home.png',
        selected: false
      },
      {
        text: 'Verticals',
        to: '/verticales/',
        image: 'hoteleria_cityexpressv2.jpg',
        selected: false,
        items: [
          {
            text: 'HOTEL',
            to: '/verticales/hotel',
            image: 'hoteleria_cityexpressv2.jpg',
            selected: false
          },
          {
            text: 'HOSPITALS',
            to: '/verticales/hospital',
            image: 'Headers/hospitalario.png',
            selected: false
          },
          {
            text: 'GOVERNMENT',
            to: '/verticales/government',
            image: 'Headers/gobierno.png',
            selected: false
          },
          {
            text: 'INDUSTRIAL',
            to: '/verticales/industrial',
            image: 'Headers/industrial.png',
            selected: false
          },
          {
            text: 'ENTERTAINMENT',
            to: '/verticales/entertainment',
            image: 'Headers/entretenimiento.png',
            selected: false
          },
          {
            text: 'RESIDENTIAL',
            to: '/verticales/residential',
            image: 'Headers/residencial.png',
            selected: false
          },
          {
            text: 'COORPORATIVE',
            to: '/verticales/corporative',
            image: 'Headers/corporativo.png',
            selected: false
          },
          {
            text: 'COMERCIAL',
            to: '/verticales/comercial',
            image: 'Headers/comercial.png',
            selected: false
          },
          {
            text: 'EDUCATION',
            to: '/verticales/education',
            image: 'Headers/educacion.png',
            selected: false
          },
          {
            text: 'PENINTENTIARY',
            to: '/verticales/penitentiary',
            image: 'Headers/penitenciaria.png',
            selected: false
          }
        ]
      }
    ]
  }),
  computed: {
    windowSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 0
        case 'sm': return 1
        case 'md': return 2
        case 'lg': return 3
        case 'xl': return 4
        default: return 0
      }
    }
  },
  methods: {
    pushAndResetNav (route) {
      this.drawer = false
      if (this.$route.path !== route) {
        window.scrollTo(0, 0)
        this.$router.push(route)
      }
    },
    goLink (link) {
      this.links.forEach(element => {
        element.selected = false
      })
      link.selected = true
      window.scrollTo(0, 0)
      this.$router.push(link.to)
    },
    goScroll (to) {
      var link = {
        text: 'HOME',
        to: '/',
        image: 'header1_home.png',
        selected: false
      }
      this.goLink(link)
      this.$scrollTo.scrollTo(to)
    },
    updateBackground () {
      switch (this.$route.path) {
        case '/':
          this.currentImage = require('./assets/' + this.links[0].image)
          this.links[0].selected = true
          break
        case '/verticales/hotel':
          this.currentImage = require('./assets/' + this.links[1].image)
          this.links[1].selected = true
          break
        case '/verticales/residential':
          this.currentImage = require('./assets/Headers/residencial.png')
          this.links[1].selected = true
          break
        case '/verticales/hospital':
          this.currentImage = require('./assets/Headers/hospitalario.png')
          this.links[1].selected = true
          break
        case '/verticales/corporative':
          this.currentImage = require('./assets/Headers/corporativo.png')
          this.links[1].selected = true
          break
        case '/verticales/government':
          this.currentImage = require('./assets/Headers/gobierno.png')
          this.links[1].selected = true
          break
        case '/verticales/comercial':
          this.currentImage = require('./assets/Headers/comercial.png')
          this.links[1].selected = true
          break
        case '/verticales/industrial':
          this.currentImage = require('./assets/Headers/industrial.png')
          this.links[1].selected = true
          break
        case '/verticales/education':
          this.currentImage = require('./assets/Headers/educacion.png')
          this.links[1].selected = true
          break
        case '/verticales/entertainment':
          this.currentImage = require('./assets/Headers/entretenimiento.png')
          this.links[1].selected = true
          break
        case '/verticales/penitentiary':
          this.currentImage = require('./assets/Headers/penitenciarias.png')
          this.links[1].selected = true
          break
      }
    }
  },
  updated () {
    this.updateBackground()
    this.vertical = this.$route.params.vertical
  },
  mounted () {
    this.updateBackground()
    this.vertical = this.$route.params.vertical
  },
  created () {
    // setInterval(() => {
    //   if (++this.windowHome >= 1) this.window = 0
    // }, 8000)
    this.vertical = this.$route.params.vertical
  }
}
</script>

<style>
html, body {
  overflow-x: hidden;
}
body {
  position: relative
}
p {
  text-align: justify;
  text-align-last: left;
}
.navbar {
  background-image: url('./assets/header1_home.png');
  background-color: black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.line {
  position: relative;
  width: 15%;
  border-width: 0.1em;
  top: 1.7em;
  right: 4em;
  border-color: #f05f32;
  z-index: 0;
}
.line2 {
  position: absolute;
  width: 13%;
  border-width: 0.1em;
  top: 9em;
  left: 3em;
  border-color: #f05f32;
  z-index: 0;
}
.align {
  transform: translateY(23%);
}
</style>
